import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
export const Device = props => {
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("path", { d: "M15.81,3.00818182 L7.62818182,3 C6.72818182,3 6,3.73636364 6,4.63636364 L6,19.3636364 C6,20.2636364 6.72818182,21 7.62818182,21 L15.81,21 C16.71,21 17.4463636,20.2636364 17.4463636,19.3636364 L17.4463636,4.63636364 C17.4463636,3.73636364 16.71,3.00818182 15.81,3.00818182 Z M15.81,17.7272727 L7.62818182,17.7272727 L7.62818182,6.27272727 L15.81,6.27272727 L15.81,17.7272727 Z" })));
};
export default Device;
